import { Box, Text, Title } from "@mantine/core";
import type { TitleOrder } from "@mantine/core";
import type { AriaRole, ReactNode } from "react";
import classes from "./StateCard.module.css";

export interface StateCardProps {
  /** Дүрс (жишээ нь `<WarningCircleIcon size={24} />`); tone-ын дэвсгэртэй тойрогт орно. */
  icon?: ReactNode;
  tone?: "neutral" | "error";
  title: ReactNode;
  description?: ReactNode;
  /** Товч(ууд); мөрөөр, 8 px зайтай. */
  actions?: ReactNode;
  /**
   * card = цагаан хүрээтэй карт (canvas 3.6 States, 2.x Home, 2.1 Businesses);
   * plain = хүрээгүй, зүүн тийш, том гарчигтай — нэвтрэх хүрээн дотор (VerifyErrorState).
   */
  variant?: "card" | "plain";
  role?: AriaRole;
  /**
   * Зөвхөн card-д: sm = Businesses-ийн жижиг зүүн тийш карт (дүрсгүй),
   * md = States самбарын төвлөрсөн карт, lg = нүүрний хоосон төлөв (Home).
   */
  size?: "sm" | "md" | "lg";
  /** Гарчгийн heading түвшин. */
  titleOrder?: TitleOrder;
}

/** Хоосон / алдаа / мэдээллийн төлөв. Мөнхөд эргэх loader-ийн оронд. */
export function StateCard({
  icon,
  tone = "neutral",
  title,
  description,
  actions,
  variant = "card",
  role,
  size = "md",
  titleOrder = 2,
}: StateCardProps) {
  return (
    <Box role={role} className={classes.root} data-variant={variant} data-size={variant === "card" ? size : undefined}>
      {icon && (
        <Box component="span" className={classes.icon} data-tone={tone} aria-hidden="true">
          {icon}
        </Box>
      )}
      <Title order={titleOrder} className={classes.title}>
        {title}
      </Title>
      {description && <Text className={classes.description}>{description}</Text>}
      {actions && <Box className={classes.actions}>{actions}</Box>}
    </Box>
  );
}
